import type { TeamPlayer } from "../../../types";

const MENTION_REGEX = /@\[(.+?)\]\((\d+)\)/g;

export function getTaggedPlayerIds(text: string): Set<number> {
	const ids = new Set<number>();
	const regex = new RegExp(MENTION_REGEX.source, "g");
	let match;
	while ((match = regex.exec(text)) !== null) {
		ids.add(Number(match[2]));
	}
	return ids;
}

export function insertMention(currentText: string, player: TeamPlayer): string {
	const mention = `@[${player.name}](${player.id})`;
	const separator = currentText.trim().length > 0 && !currentText.endsWith(" ") ? " " : "";
	return currentText + separator + mention + " ";
}

export function removeMention(currentText: string, playerId: number): string {
	const regex = new RegExp(`@\\[([^\\]]+)\\]\\(${playerId}\\)\\s?`, "g");
	return currentText.replace(regex, "");
}
